export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Sirve si soy terapeuta en formación o recién graduado?',
    a: 'Sí, está diseñado exactamente para eso. Cada protocolo tiene la imagen anatómica del área tratada con los puntos marcados, el diagnóstico diferencial según la MTC, la técnica específica y las contraindicaciones. No necesitás años de experiencia para usarlo con criterio: el atlas te da la estructura. Tu formación pone el diagnóstico. Los dos juntos producen sesiones de alto nivel desde el primer día.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga de los 3 tomos en PDF más los 6 bonos completos. Acceso en menos de 5 minutos desde cualquier dispositivo. Sin esperas, sin envíos físicos.',
  },
  {
    q: '¿Necesito imprimir todo el material?',
    a: 'No es obligatorio. El diseño está optimizado para usarse en tablet o pantalla durante la sesión clínica, lo cual es especialmente práctico para los protocolos del Tomo II. Si preferís imprimirlo, el formato A4 con alta calidad gráfica permite una impresión de nivel profesional que podés dejar en la camilla para mostrarle al paciente.',
  },
  {
    q: '¿En qué se diferencia de un libro de acupuntura tradicional?',
    a: 'Los manuales tradicionales de acupuntura son textos académicos: cientos de páginas densas, diagramas en blanco y negro y texto minúsculo que nadie abre en el medio de una sesión. El Atlas Ancestral es una herramienta de consulta clínica diseñada específicamente para usar mientras el paciente está en la camilla. Cada protocolo tiene imagen anatómica del área con los puntos marcados, técnica específica y contraindicaciones en una sola página visual. No es para estudiar. Es para usar.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total desde el momento de la compra. Si por cualquier motivo no cumple tus expectativas, te devolvemos el 100% sin preguntas. Escribinos a soportelumenakasha@gmail.com.',
  },
  {
    q: '¿Puedo compartirlo con otros terapeutas del equipo?',
    a: 'El material es de uso personal y está protegido por derechos de autor. Si trabajás en equipo o coordinás una escuela de terapeutas y querés una licencia grupal, escribinos por WhatsApp al 11 5339-9780 y coordinamos.',
  },
]
